var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.isAuthenticated)?_c('the-sidebar'):_vm._e(),(_vm.isAuthenticated)?_c('the-topbar'):_vm._e(),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[(!_vm.isMotor || !_vm.isAuthenticated)?_c('router-view'):_c('driver-menu')],1),_c('wot-fab-scroll')],1),_c('wot-snackbar'),(_vm.isLoading)?_c('wot-loading'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }